<template>
  <v-select
    v-model="modelValue"
    item-text="keyValue"
    item-value="keyValue"
    :items="items"
    :error-messages="errorMessages"
    :label="label"
    :loading="loading"
    :disabled="disabled"
    @change="onChange"
  />
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'SectionDropdown',

    props: {
      value: {
        type: String,
        default: null,
      },
      section: {
        type: String,
        default: null,
      },
      errorMessages: {
        type: Object,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
        default: null,
      },
    },

    data: () => ({
      items: null,

      loading: false,

      dropdownDetailResource: new TroodyApi('dropdownDetail/'),
    }),

    computed: {
      modelValue: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('update:value', value)
        },
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.loading = true

        this.dropdownDetailResource.query({ section: this.section })
          .then(data => {
            this.items = data
            this.loading = false
          })
          .catch((error) => {
            this.loading = false
            console.log(error)
          })
      },

      onChange (value) {
        this.$emit('change', value)
      },
    },
  }
</script>
